import { QcqQualityResponse } from '@/types/service-response'

export class Quality {
  private constructor (
    readonly competences: boolean,
    readonly employees: boolean,
    readonly numbersOfStars: number,
    readonly isEditable: boolean
  ) {}

  static createFromQcqQualityResponse (responseData: QcqQualityResponse): Quality {

    return new Quality(
      responseData.qualityByKompetezen,
      responseData.qualityByMitarbeiter,
      responseData.starsNumber,
      responseData.isEditable
    )
  }

  static createFromQcqQualityData (competence: boolean, employee: boolean, starsNumber: number, isEditable: boolean): Quality {

    return new Quality(
      competence,
      employee,
      starsNumber,
      isEditable
    )
  }

}